export const SmsLanguage = {
    GERMAN : 'SmsLanguage.GERMAN',
    ENGLISH : 'SmsLanguage.ENGLISH',
    UKRAINIAN : 'SmsLanguage.UKRAINIAN',
    RUSSIAN : 'SmsLanguage.RUSSIAN'
}